module.exports = __webpack_public_path__ + "media/images/icons/star-3-blue-7be0770b3171fbbf0802c3f680887946.svg";